var _excluded = ["id", "inline", "disabled", "children", "containerClassName", "type", "value"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classname from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Input from '../Input/Input';
import Label from '../Label/Label';
import FormGroup from './FormGroup';
var count = 0;

function getID() {
  return `form-choice-${count++}`;
}

class FormChoice extends React.Component {
  constructor(props) {
    super(props);
    this.id = props.id || getID();
  }

  render() {
    /* eslint-disable-next-line  @typescript-eslint/no-unused-vars -- Let's figure out a better way to omit props for this scenario */
    var _this$props = this.props,
        id = _this$props.id,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        children = _this$props.children,
        containerClassName = _this$props.containerClassName,
        type = _this$props.type,
        value = _this$props.value,
        attributes = _objectWithoutProperties(_this$props, _excluded);

    if (type === 'select') {
      return /*#__PURE__*/React.createElement("option", _extends({}, attributes, {
        disabled: disabled,
        value: value
      }), children);
    }

    var containerClasses = classname({
      'form-check-inline': inline
    }, containerClassName);
    var computedValue = value || children;
    var item = /*#__PURE__*/React.createElement("div", {
      className: containerClasses
    }, /*#__PURE__*/React.createElement(Input, _extends({
      id: this.id,
      type: type
    }, attributes, {
      disabled: disabled,
      value: computedValue,
      style: {
        cursor: disabled && 'not-allowed'
      }
    })), /*#__PURE__*/React.createElement(Label, {
      className: "form-check-label",
      check: !inline,
      for: this.id,
      style: {
        cursor: disabled && 'not-allowed'
      }
    }, children));

    if (inline) {
      return item;
    }

    return /*#__PURE__*/React.createElement(FormGroup, {
      check: true,
      disabled: disabled
    }, item);
  }

}

_defineProperty(FormChoice, "propTypes", {
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio', 'select']),
  value: PropTypes.any
});

FormChoice.displayName = "FormChoice";
export default FormChoice;